import React from "react";

import { useGetFormattedEmployeeDataQuery } from "EmployerApplication/api";

import EditEmployeePriceBreakdownBody from "../EditEmployeePriceBreakdown/EditEmployeePriceBreakdownBody";
import { TitleSmall } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Button from "Common/Button";
import EnterAgesTable from "Common/EnterAges/Components/EnterAgesTable";
import Icon from "Common/Icon";
import { Tabs, Tab } from "Common/Tabs/Tabs";

import makeBem from "Utils/makeBem";

const bem = makeBem("EditCartEmployeesModal");

const EditCartEmployeesModal = ({ triggerText, contributionType, contributions }) => {
  const { refetch: refetchFormattedEmployeeData } = useGetFormattedEmployeeDataQuery();
  return (
    <StandaloneTrigger
      trigger={(props) => (
        <a
          href="#"
          {...props}
          onClick={(e) => {
            props.onClick(e);
            refetchFormattedEmployeeData();
          }}
        >
          <Icon icon="pencil-alt" flavor="solid" pr={2} />
          Edit Employees
        </a>
      )}
      modal={(props) => (
        <Modal {...props} className={bem()}>
          <ModalHeader closeButton>
            <TitleSmall mb={0} mt={0}>
              Edit Employee Details
            </TitleSmall>
          </ModalHeader>
          <ModalBody>
            <Tabs>
              <Tab label="employeeList" tabName="Employee list">
                <EnterAgesTable showAddButton />
              </Tab>
              <Tab label="monthlyCost" tabName="Monthly cost">
                <EditEmployeePriceBreakdownBody contributionType={contributionType} contributions={contributions} />
              </Tab>
            </Tabs>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => props.onHide()}>Finish</Button>
          </ModalFooter>
        </Modal>
      )}
    />
  );
};

export default EditCartEmployeesModal;
